<template>
  <BaseDialog
    :visible="modelValue"
    class="!w-[90%] md:!w-[50%] h-[80vh] sm:h-[85vh] md:h-[90vh]"
    @update:visible="(val) => $emit('update:modelValue', val)"
  >
    <div
      class="flex justify-between w-full px-[32px] md:pt-[25.52px] pt-[21.85px]"
    >
      <div class="flex gap-[8px] !w-full"></div>
      <button
        @click="close"
        class="cursor-pointer border-none bg-transparent px-0 flex justify-center items-center"
        v-html="cancelSvg"
      ></button>
    </div>
    <div
      :style="{
        backgroundImage: `url(${dashboardBg})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundSize: '50% auto',
      }"
      class="!px-[24px] md:!px-[35px] md:pt-[37px] pt-[24px]"
    >
      <div class="flex justify-center items-center">
        <div
          class="flex justify-center items-center rounded-full bg-gradient-to-r from-mintGradientFrom to-mintGradientTo md:px-[20.84px] md:pt-[26.79px] md:pb-[29.77px] px-[14px] pt-[18px] pb-[20px]"
          v-html="successIcon"
        ></div>
      </div>

      <div
        class="md:pt-[37px] pt-[24px] flex justify-center items-center !w-full !m-0"
      >
        <p
          class="font-500 md:text-[32px] sm:text-[24px] font-just text-btnActive leading-[100%] text-center text-balance"
        >
          {{ $t('subscriptionLabels.success') }}
        </p>
      </div>

      <div
        class="md:pt-[37px] pt-[24px] !w-full pb-[53.85px] md:pb-[80.85px] flex justify-center items-center text-center"
      >
        <p
          class="!font-just !font-400 !text-[16px] text-smokyBlack leading-[23px]"
        >
          {{ $t('subscriptionLabels.discount') }}
        </p>
      </div>
    </div>
  </BaseDialog>
</template>

<script setup>
import { computed } from 'vue';
import { closeSvg, successSvg } from '@/utils/commonSvg';
import { useI18n } from "vue-i18n";
const dashboardBg = new URL("@/assets/images/dashboard.png", import.meta.url)
  .href;

const { t } = useI18n();

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(['update:modelValue']);

// Close handler
const close = () => {
  emit('update:modelValue', false);
};

// Generate success icon
const successIcon = computed(() => {
  return successSvg({
    height: '32.74',
    width: '47.63',
  });
});

// Generate close icon
const cancelSvg = computed(() =>
  closeSvg({
    height: '24',
    width: '24',
  })
);
</script>
